function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { Button } from '@signicat/designi/components/buttons';
import { TextField, Select, Toggle, Checkbox } from '@signicat/designi/components/inputs';
import { Flex, Grid, Row, Column } from '@signicat/designi/components/layout';
import { Heading } from '@signicat/designi/components/text';
import { Segment } from '@signicat/designi/components/containers';
import { Message } from '@signicat/designi/components/messages';
import { Form, Field } from '@signicat/designi/components/forms';
import { media } from '@signicat/designi/helpers/responsive';
import { Icon } from '@signicat/designi/components/icons';
import { Feature } from '@signiapp/core/components';
import coreStore from '@signiapp/core/store';
import { t } from "../../../helpers/i18n";
import { signer as signerValidator } from "../../../store/validators";
import { allowShareSelector, allowEmailNotificationSelector, emailNotificationStateSelector, smsNotificationStateSelector, availableLanguagesSelector, signerSignMechanismSelector, signingOrderErrorSignerSelector, signingOrderSignMechanismSelector, signingOrderAvailableSigningMethods, defaultRecipientLanguageSelector, defaultSignatureMethodsSelector } from "../../../store/selectors/orders";
import { isEqual } from 'lodash';
var phoneUtil = PhoneNumberUtil.getInstance();
var validateEmail = function validateEmail(email) {
  return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
var StyledFlex = styled(Flex).withConfig({
  displayName: "SignerEdit__StyledFlex",
  componentId: "sc-1w9tw8z-0"
})(["width:fit-content;"]);
var SignerEdit = function SignerEdit(props) {
  var _signerData$signature, _signerData$addons5, _order$uiFeatures17, _signerData$addons6, _order$uiFeatures18, _order$uiFeatures18$s, _order$uiFeatures19, _order$uiFeatures20, _order$uiFeatures21, _order$uiFeatures22;
  var portalHasContactModule = coreStore.getState().app.modules.some(function (x) {
    return x.id === 'contact';
  });
  var _useSelector = useSelector(function (state) {
      return state.create;
    }),
    features = _useSelector.features;
  var order = useSelector(function (state) {
    return state.create.data;
  });
  var signerId = props.signerId,
    onDone = props.onDone,
    onChange = props.onChange,
    onCancel = props.onCancel,
    signer = props.signer,
    requiredDisabled = props.requiredDisabled;
  var isSaving = signer.isSaving,
    isContact = signer.isContact;
  var orderId = 'create';
  var _useState = useState(signer.data),
    _useState2 = _slicedToArray(_useState, 2),
    signerData = _useState2[0],
    setSignerData = _useState2[1];
  var defaultSignatureMethods = useSelector(defaultSignatureMethodsSelector(orderId, signerId));
  var _useState3 = useState((defaultSignatureMethods === null || defaultSignatureMethods === void 0 ? void 0 : defaultSignatureMethods.length) > 0),
    _useState4 = _slicedToArray(_useState3, 2),
    prefillSignMethods = _useState4[0],
    setPrefillSignMethods = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(!!signerData.email),
    _useState8 = _slicedToArray(_useState7, 2),
    emailState = _useState8[0],
    setEmailState = _useState8[1];
  var _useState9 = useState(!!signer.data.mobileNumber),
    _useState10 = _slicedToArray(_useState9, 2),
    mobileNumberState = _useState10[0],
    setMobileNumberState = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    SMSNotificationFeatureEnabled = _useState12[0],
    setSMSNotificationFeatureEnabled = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    validateAll = _useState14[0],
    setValidateAll = _useState14[1];
  var allowShare = useSelector(function (state) {
    return allowShareSelector(state, orderId, signerId);
  });
  var allowEmailNotification = useSelector(function (state) {
    return allowEmailNotificationSelector(state, orderId, signerId);
  });
  var emailNotificationState = useSelector(function (state) {
    return emailNotificationStateSelector(state, orderId, signerId);
  });
  var smsNotificationState = useSelector(function (state) {
    return smsNotificationStateSelector(state, orderId, signerId);
  });
  var allowMultipleSignMechanisms = Boolean(useSelector(function (state) {
    var _state$create$data, _state$create$data$ui;
    return (_state$create$data = state.create.data) === null || _state$create$data === void 0 ? void 0 : (_state$create$data$ui = _state$create$data.uiFeatures) === null || _state$create$data$ui === void 0 ? void 0 : _state$create$data$ui.allowMultipleSignMechanisms;
  }));
  var stack = useSelector(function (state) {
    return state.create.data.advanced.stack;
  });
  var signingOrderSignMechanism = useSelector(signingOrderSignMechanismSelector(orderId));
  var signerSignMechanism = useSelector(signerSignMechanismSelector(orderId, signerId));
  var signingOrderErrorSigner = useSelector(signingOrderErrorSignerSelector(orderId, signerId));
  var signMechanismsAndIdps = useSelector(function (state) {
    return state.module.stacks[stack].signMechanisms;
  });
  var availableSigninMethods = useSelector(signingOrderAvailableSigningMethods(orderId));
  useEffect(function () {
    var errors = [];
    if ((signingOrderErrorSigner === null || signingOrderErrorSigner === void 0 ? void 0 : signingOrderErrorSigner.error) != null) {
      errors.push(signingOrderErrorSigner === null || signingOrderErrorSigner === void 0 ? void 0 : signingOrderErrorSigner.error);
    }
    setErrors(errors);
  }, [signingOrderErrorSigner]);
  useEffect(function () {
    var updateSigner = _objectSpread({}, signerData);
    // Filter out invalid methods (if removed as allowed methods etc.)
    var updateMethods = defaultSignatureMethods === null || defaultSignatureMethods === void 0 ? void 0 : defaultSignatureMethods.filter(function (dm) {
      var _signMechanismsAndIdp;
      var allowdIdpsForMech = (_signMechanismsAndIdp = signMechanismsAndIdps[dm.signMechanism]) === null || _signMechanismsAndIdp === void 0 ? void 0 : _signMechanismsAndIdp.map(function (m) {
        return m.idp;
      });
      var availability = checkIfMechanismAllowedOnOrder(dm.signMechanism);
      return (allowdIdpsForMech === null || allowdIdpsForMech === void 0 ? void 0 : allowdIdpsForMech.includes(dm.idp)) && !(availability.disabledByPki || availability.disabledByHandwritten);
    });
    if ((updateMethods === null || updateMethods === void 0 ? void 0 : updateMethods.length) > 0 && prefillSignMethods && updateSigner && (!updateSigner.signatureMethods || updateSigner.signatureMethods.length <= 0)) {
      updateSigner.signatureMethods = updateMethods;
      setSignerData(updateSigner);
      onChange(updateSigner);
    }
  }, [defaultSignatureMethods]);
  var pkiIsAvailable = Boolean(Object.keys(signMechanismsAndIdps) || [].find(function (signMechanism) {
    return /pki/.test(signMechanism);
  }));
  var handleSignerChange = function handleSignerChange(field) {
    return function (e) {
      var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, _defineProperty({}, field, e.target.value));
      onChange(updatedSignerData);
      setSignerData(updatedSignerData);
    };
  };
  var handleSignerToggle = function handleSignerToggle(field) {
    return function (e) {
      var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, _defineProperty({}, field, field != 'smsNotification' || SMSNotificationFeatureEnabled ? e.target.checked : false));
      onChange(updatedSignerData);
      setSignerData(updatedSignerData);
    };
  };
  var mobileNumber = false;
  var mobileIsValid = false;
  try {
    mobileNumber = phoneUtil.parseAndKeepRawInput(signerData.mobileNumber || '', 'NO');
    mobileIsValid = phoneUtil.isValidNumber(mobileNumber);
  } catch (err) {
    // TODO: Handle?
  }
  useEffect(function () {
    setSignerData(signer.data);
  }, [signer.data]);
  useEffect(function () {
    var updatedSignerData = _objectSpread({}, signerData);
    var isValid = validateEmail(signerData.email);
    if (!signerData.email || !isValid) {
      uncheckEmailNotificationAndShare();
      setEmailState(false);
    } else if (!emailState && isValid) {
      var _order$uiFeatures, _order$uiFeatures2, _order$uiFeatures3, _signerData$addons;
      updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
        emailNotification: true
      });
      setEmailState(true);
      // secureShare
      var shouldBeEnabled = ['disabled_true', 'default_true'].includes((_order$uiFeatures = order.uiFeatures) === null || _order$uiFeatures === void 0 ? void 0 : _order$uiFeatures.secureShare);
      var isCompatibleWithEmailAndSms = (order === null || order === void 0 ? void 0 : (_order$uiFeatures2 = order.uiFeatures) === null || _order$uiFeatures2 === void 0 ? void 0 : _order$uiFeatures2.showShare) === 'enabled_with_email_and_sms' && mobileIsValid;
      var isCompatibleWithEmail = (order === null || order === void 0 ? void 0 : (_order$uiFeatures3 = order.uiFeatures) === null || _order$uiFeatures3 === void 0 ? void 0 : _order$uiFeatures3.showShare) === 'enabled_with_email' && (signerData.signatureMethods.every(function (x) {
        return x.signMechanism !== 'handwritten';
      }) || mobileIsValid);
      if (!Boolean((_signerData$addons = signerData.addons) === null || _signerData$addons === void 0 ? void 0 : _signerData$addons.shareDocumentAfterSigned) && shouldBeEnabled && (isCompatibleWithEmailAndSms || isCompatibleWithEmail)) {
        updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
          addons: _objectSpread(_objectSpread({}, updatedSignerData.addons), {}, {
            shareDocumentAfterSigned: true
          })
        });
      }
      onChange(updatedSignerData);
      setSignerData(updatedSignerData);
    }
  }, [signerData.email]);
  useEffect(function () {
    var _signerData$addons2;
    if (signerData.signerRoles && (_signerData$addons2 = signerData.addons) !== null && _signerData$addons2 !== void 0 && _signerData$addons2.shareDocumentAfterSigned && !allowShare) {
      handleSignerShareChange({
        target: {
          checked: false
        }
      });
    }
  }, [signerData.signerRoles]);

  // SMSNotificationFeatureEnabled - feature flag
  // mobileNumberState => double check to avoid repetition AND to prevent watcher on opening existing recipient

  useEffect(function () {
    var _order$uiFeatures9, _order$uiFeatures10;
    var updatedSignerData = _objectSpread({}, signerData);
    if (!signerData.mobileNumber || !mobileIsValid || !SMSNotificationFeatureEnabled) {
      if (mobileNumberState) {
        // sms
        if (signerData.smsNotification) updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
          smsNotification: false
        });
        // auth
        if (!signerData.mobileNumber || !mobileIsValid || signerData.authBeforeSign === 'sms') {
          updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
            authBeforeSign: 'none'
          });
        }
        setMobileNumberState(false);
      }
    } else {
      if (!mobileNumberState) {
        var _order$uiFeatures4, _order$uiFeatures5, _order$uiFeatures6, _order$uiFeatures7, _order$uiFeatures8, _signerData$addons3;
        // sms
        if (['disabled_true', 'default_true'].includes((_order$uiFeatures4 = order.uiFeatures) === null || _order$uiFeatures4 === void 0 ? void 0 : _order$uiFeatures4.smsNotification) && SMSNotificationFeatureEnabled) updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
          smsNotification: true
        });
        // auth
        if (signerData.authBeforeSign === 'none' && ['disabled_true', 'default_true'].includes((_order$uiFeatures5 = order.uiFeatures) === null || _order$uiFeatures5 === void 0 ? void 0 : _order$uiFeatures5.requireAuthentication)) updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
          authBeforeSign: 'sms'
        });

        // secureShare
        var shouldBeEnabled = ['disabled_true', 'default_true'].includes((_order$uiFeatures6 = order.uiFeatures) === null || _order$uiFeatures6 === void 0 ? void 0 : _order$uiFeatures6.secureShare);
        var isCompatibleWithEmailAndSms = (order === null || order === void 0 ? void 0 : (_order$uiFeatures7 = order.uiFeatures) === null || _order$uiFeatures7 === void 0 ? void 0 : _order$uiFeatures7.showShare) === 'enabled_with_email_and_sms' && emailState;
        var isCompatibleWithEmail = emailState && (order === null || order === void 0 ? void 0 : (_order$uiFeatures8 = order.uiFeatures) === null || _order$uiFeatures8 === void 0 ? void 0 : _order$uiFeatures8.showShare) === 'enabled_with_email' && (signerData.signatureMethods.every(function (x) {
          return x.signMechanism !== 'handwritten';
        }) || mobileIsValid);
        if (!Boolean((_signerData$addons3 = signerData.addons) === null || _signerData$addons3 === void 0 ? void 0 : _signerData$addons3.shareDocumentAfterSigned) && shouldBeEnabled && (isCompatibleWithEmailAndSms || isCompatibleWithEmail)) {
          updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
            addons: _objectSpread(_objectSpread({}, signerData.addons), {}, {
              shareDocumentAfterSigned: true
            })
          });
        }
        setMobileNumberState(true);
      }
    }

    // sms otp
    if (!mobileIsValid && signerData.signatureMethods.some(function (x) {
      return x.idp === 'sms_otp';
    })) {
      var currentSignatureMethods = signerData.signatureMethods || [];
      var updatedSignatureMethods = currentSignatureMethods.filter(function (signatureMethod) {
        return signatureMethod.idp !== 'sms_otp';
      });
      updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
        signatureMethods: updatedSignatureMethods
      });
    }

    // secureShare(only if requires sms)
    if (!mobileIsValid && ((order === null || order === void 0 ? void 0 : (_order$uiFeatures9 = order.uiFeatures) === null || _order$uiFeatures9 === void 0 ? void 0 : _order$uiFeatures9.showShare) === 'enabled_with_email_and_sms' || (order === null || order === void 0 ? void 0 : (_order$uiFeatures10 = order.uiFeatures) === null || _order$uiFeatures10 === void 0 ? void 0 : _order$uiFeatures10.showShare) === 'enabled_with_email' && signerData.signatureMethods.some(function (x) {
      return x.signMechanism === 'handwritten';
    }))) {
      updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
        addons: _objectSpread(_objectSpread({}, updatedSignerData.addons), {}, {
          shareDocumentAfterSigned: false
        })
      });
    }
    if (!isEqual(updatedSignerData, signerData)) {
      onChange(updatedSignerData);
      setSignerData(updatedSignerData);
    }
  }, [signerData.mobileNumber]);
  useEffect(function () {
    var _order$uiFeatures11;
    if (!SMSNotificationFeatureEnabled) {
      if (mobileNumberState) setMobileNumberState(false);
      uncheckSmsNotification();
    } else if (!!signerData.mobileNumber && mobileIsValid && SMSNotificationFeatureEnabled && mobileNumberState === false && ['disabled_true', 'default_true'].includes((_order$uiFeatures11 = order.uiFeatures) === null || _order$uiFeatures11 === void 0 ? void 0 : _order$uiFeatures11.smsNotification)) {
      setMobileNumberState(true);
      checkSmsNotification();
    }
  }, [SMSNotificationFeatureEnabled]);
  var setAuthBeforeSign = function setAuthBeforeSign(val) {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      authBeforeSign: val
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var handleAuthBeforeSignToggle = function handleAuthBeforeSignToggle(e) {
    var val = e.target.checked ? 'sms' : 'none';
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      authBeforeSign: val
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var handleSignerShareChange = function handleSignerShareChange(e) {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      addons: _objectSpread(_objectSpread({}, signerData.addons), {}, {
        shareDocumentAfterSigned: e.target.checked
      })
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var handleCancelClick = function handleCancelClick() {
    onCancel(signerData);
  };
  var saveAndClose = function saveAndClose() {
    setValidateAll(true);
    if (Object.entries(validation).length === 0) {
      onDone(signerData);
    } else {}
  };
  var handleHandwrittenToggle = function handleHandwrittenToggle(e) {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      addHandwrittenSignature: e.target.checked
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var handleAddToContacts = function handleAddToContacts(e) {
    var checked = e.target.checked;
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      addons: _objectSpread(_objectSpread({}, signerData.addons), {}, {
        addToContacts: checked
      })
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var disableAddHandwrittenSignature = Boolean((_signerData$signature = signerData.signatureMethods) === null || _signerData$signature === void 0 ? void 0 : _signerData$signature.find(function (s) {
    return s.signMechanism === 'handwritten';
  }));

  /* Options in the UI */

  var availableLanguages = useSelector(availableLanguagesSelector('create'));
  var defaultLanguage = useSelector(defaultRecipientLanguageSelector('create'));
  var languageOptions = availableLanguages.map(function (language) {
    return {
      value: language,
      text: t("language_option_".concat(language))
    };
  }).sort(function (a, b) {
    return a.text > b.text ? 1 : a.text === b.text ? 0 : -1;
  });
  useEffect(function () {
    if (!(signerData !== null && signerData !== void 0 && signerData.language)) {
      var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
        language: defaultLanguage
      });
      setSignerData(updatedSignerData);
      onChange(updatedSignerData);
    }
  }, [signerData === null || signerData === void 0 ? void 0 : signerData.language]);
  var signMethodsDependencies = {
    sms_otp: mobileIsValid ? false : 'dependent_field_mobile_number'
  };
  var checkIfMechanismAllowedOnOrder = function checkIfMechanismAllowedOnOrder(signMechanism) {
    var disabledByPki = allowMultipleSignMechanisms ? false : signingOrderSignMechanism && signMechanism === 'pki_signature' ? signingOrderSignMechanism !== 'pki_signature' : signingOrderSignMechanism === 'pki_signature';
    var disabledByHandwritten = allowMultipleSignMechanisms ? false : signerSignMechanism && signMechanism === 'handwritten' ? signerSignMechanism !== 'handwritten' : signerSignMechanism === 'handwritten';
    return {
      disabledByPki: disabledByPki,
      disabledByHandwritten: disabledByHandwritten
    };
  };
  var signMethodsOptions = (Object.keys(availableSigninMethods) || []).filter(function (signMechanism) {
    return signMechanismsAndIdps[signMechanism] && signMechanismsAndIdps[signMechanism].length > 0;
  }).map(function (signMechanism) {
    var availability = checkIfMechanismAllowedOnOrder(signMechanism);
    var disabled = availability.disabledByHandwritten || availability.disabledByPki;
    return {
      text: "".concat(t("sign_mechanism_".concat(signMechanism))).concat(disabled ? " (".concat(t(availability.disabledByPki ? 'sign_mechanisms_hint_cannot_be_combined_with_pki' : 'sign_mechanisms_hint_cannot_be_combined_with_other'), ")") : ''),
      value: signMechanism,
      disabled: disabled,
      options: signMechanismsAndIdps[signMechanism].map(function (idp) {
        return {
          value: idp.idp,
          text: "".concat(t("idp_".concat(idp.idp))).concat(signMethodsDependencies[idp.idp] ? " (".concat(t(signMethodsDependencies[idp.idp]), ")") : '')
        };
      })
    };
  });
  var setSignMethods = function setSignMethods(signMethods) {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      signatureMethods: signMethods
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var onSignMethodsChange = function onSignMethodsChange(e) {
    var _signerData$addons4, _order$uiFeatures15, _order$uiFeatures16;
    var updatedSignerData = _objectSpread({}, signerData);
    var signMethods = e.target.value.map(function (s) {
      return {
        signMechanism: s.split('.')[0],
        idp: s.split('.')[1]
      };
    });
    setPrefillSignMethods(false); //Clear default methods when user has manually cleared them
    updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
      signatureMethods: signMethods
    });

    // secureShare
    if (!Boolean((_signerData$addons4 = signerData.addons) === null || _signerData$addons4 === void 0 ? void 0 : _signerData$addons4.shareDocumentAfterSigned)) {
      var _order$uiFeatures12, _order$uiFeatures13, _order$uiFeatures14;
      var shouldBeEnabled = ['disabled_true', 'default_true'].includes((_order$uiFeatures12 = order.uiFeatures) === null || _order$uiFeatures12 === void 0 ? void 0 : _order$uiFeatures12.secureShare);
      var isCompatibleWithEmailAndSms = (order === null || order === void 0 ? void 0 : (_order$uiFeatures13 = order.uiFeatures) === null || _order$uiFeatures13 === void 0 ? void 0 : _order$uiFeatures13.showShare) === 'enabled_with_email_and_sms' && emailState && mobileIsValid;
      var isCompatibleWithEmail = emailState && (order === null || order === void 0 ? void 0 : (_order$uiFeatures14 = order.uiFeatures) === null || _order$uiFeatures14 === void 0 ? void 0 : _order$uiFeatures14.showShare) === 'enabled_with_email' && (signerData.signatureMethods.every(function (x) {
        return x.signMechanism !== 'handwritten';
      }) || mobileIsValid);
      if (shouldBeEnabled && (isCompatibleWithEmailAndSms || isCompatibleWithEmail)) {
        updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
          addons: _objectSpread(_objectSpread({}, signerData.addons), {}, {
            shareDocumentAfterSigned: true
          })
        });
      }
    } else if (!emailState || !mobileIsValid && ((order === null || order === void 0 ? void 0 : (_order$uiFeatures15 = order.uiFeatures) === null || _order$uiFeatures15 === void 0 ? void 0 : _order$uiFeatures15.showShare) === 'enabled_with_email_and_sms' || (order === null || order === void 0 ? void 0 : (_order$uiFeatures16 = order.uiFeatures) === null || _order$uiFeatures16 === void 0 ? void 0 : _order$uiFeatures16.showShare) === 'enabled_with_email' && updatedSignerData.signatureMethods.some(function (x) {
      return x.signMechanism === 'handwritten';
    }))) {
      updatedSignerData = _objectSpread(_objectSpread({}, updatedSignerData), {}, {
        addons: _objectSpread(_objectSpread({}, updatedSignerData.addons), {}, {
          shareDocumentAfterSigned: false
        })
      });
    }
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var unselectSmsOtp = function unselectSmsOtp() {
    var currentSignatureMethods = signerData.signatureMethods || [];
    var updatedSignatureMethods = currentSignatureMethods.filter(function (signatureMethod) {
      return signatureMethod.idp !== 'sms_otp';
    });
    setSignMethods(updatedSignatureMethods);
  };
  var onSignerRoleChange = function onSignerRoleChange(id) {
    return function (e) {
      var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
        signerRoles: _objectSpread(_objectSpread({}, signerData.signerRoles), {}, _defineProperty({}, id, e.target.value))
      });
      onChange(updatedSignerData);
      setSignerData(updatedSignerData);
    };
  };
  var uncheckEmailNotificationAndShare = function uncheckEmailNotificationAndShare() {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      emailNotification: false,
      addons: _objectSpread(_objectSpread({}, signerData.addons || {}), {}, {
        shareDocumentAfterSigned: false
      })
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var checkEmailNotification = function checkEmailNotification() {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      emailNotification: true
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var uncheckSmsNotification = function uncheckSmsNotification() {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      smsNotification: false
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var checkSmsNotification = function checkSmsNotification() {
    var updatedSignerData = _objectSpread(_objectSpread({}, signerData), {}, {
      smsNotification: true
    });
    onChange(updatedSignerData);
    setSignerData(updatedSignerData);
  };
  var validation = signerValidator(signerData, order);
  var signerRoleEl = function signerRoleEl(fileInfo) {
    return /*#__PURE__*/React.createElement(Row, {
      vertical: "center",
      key: fileInfo.index,
      style: {
        marginBottom: '12px',
        opacity: signerData.signerRoles[fileInfo.id] === 'hide' ? 0.5 : 1,
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "lg",
      name: fileInfo.type === 'attachment' ? 'attachment' : 'description',
      style: {
        margin: '0 24px 0 8px'
      }
    }), /*#__PURE__*/React.createElement(Icon, {
      size: "md",
      name: signerData.signerRoles[fileInfo.id] === 'hide' ? 'eyeClosed' : 'eye',
      style: {
        marginRight: '32px'
      }
    }), fileInfo.title, /*#__PURE__*/React.createElement(Select, {
      options: fileInfo.type === 'attachment' ? [{
        text: t('signer_role_hide'),
        value: 'hide'
      }, {
        text: t('signer_role_view'),
        value: 'view'
      }] : [{
        text: t('signer_role_sign'),
        value: 'sign'
      }, {
        text: t('signer_role_hide'),
        value: 'hide'
      }, {
        text: t('signer_role_view'),
        value: 'view'
      }],
      value: signerData.signerRoles[fileInfo.id],
      onChange: onSignerRoleChange(fileInfo.id),
      style: {
        alignSelf: 'flex-end',
        minWidth: '120px',
        marginLeft: 'auto'
      }
    }));
  };
  return /*#__PURE__*/React.createElement(Flex, {
    flex: "1 0 auto",
    flexDirection: "column",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Segment, {
    outlined: true,
    padding: "24px",
    margin: "0",
    heading: t('signorder_create_recipient_edit_heading')
  }, /*#__PURE__*/React.createElement(StyledFlex, {
    flex: "1 0 auto",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Form, {
    validation: validation,
    state: {
      validateAll: validateAll
    }
  }, errors && errors.length ? /*#__PURE__*/React.createElement(Message, {
    category: "error",
    variant: "error"
  }, errors.map(function (error) {
    return /*#__PURE__*/React.createElement("div", {
      key: btoa(error.message)
    }, error.message);
  })) : null, /*#__PURE__*/React.createElement(Row, {
    vertical: "top"
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4,
    direction: "row",
    style: {
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-firstname",
    label: t('form_label_firstname'),
    value: signerData.firstName || '',
    onChange: handleSignerChange('firstName'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-lastname",
    label: t('form_label_lastname'),
    value: signerData.lastName || '',
    onChange: handleSignerChange('lastName'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, {
    name: "email"
  }, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-email",
    type: "email",
    label: t('form_label_email'),
    value: signerData.email || '',
    onChange: handleSignerChange('email'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, {
    name: "mobileNumber"
  }, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-mobilenumber",
    type: "tel",
    label: t('form_label_mobilenumber'),
    value: signerData.mobileNumber || '',
    onChange: handleSignerChange('mobileNumber'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-companyname",
    label: t('form_label_company'),
    value: signerData.companyName || '',
    onChange: handleSignerChange('companyName'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(TextField, {
    name: "signer-companyrole",
    label: t('form_label_role'),
    value: signerData.companyRole || '',
    onChange: handleSignerChange('companyRole'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(Select, {
    name: "signer-language",
    label: t('form_label_language'),
    options: languageOptions,
    value: signerData.language,
    onChange: handleSignerChange('language'),
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, {
    id: "sign-methods-dropdown",
    name: "signatureMethods"
  }, /*#__PURE__*/React.createElement(Select, {
    label: t('form_label_sign_methods'),
    options: signMethodsOptions,
    onChange: onSignMethodsChange,
    value: signerData.signatureMethods.map(function (s) {
      return "".concat(s.signMechanism, ".").concat(s.idp);
    }),
    renderValue: function renderValue(selected) {
      return selected.map(function (val) {
        return t("idp_".concat(val.split('.')[1]));
      }).join(', ');
    },
    multiple: true,
    fullWidth: true
  }))), portalHasContactModule && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    disabled: !!isContact,
    label: t('signer_option_add_to_contacts'),
    onChange: handleAddToContacts,
    checked: Boolean((_signerData$addons5 = signerData.addons) === null || _signerData$addons5 === void 0 ? void 0 : _signerData$addons5.addToContacts)
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_email_notification",
    label: t('signer_option_email_notification_label'),
    onChange: handleSignerToggle('emailNotification'),
    checked: emailNotificationState,
    helpText: t('signer_option_email_notification_helptext'),
    disabled: allowEmailNotification === false
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Feature, {
    featureId: "signature_custom_smsnotification",
    onFeatureToggle: function onFeatureToggle(e) {
      return setSMSNotificationFeatureEnabled(e);
    }
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_sms_notification",
    label: t('signer_option_sms_notification_label'),
    onChange: handleSignerToggle('smsNotification'),
    checked: smsNotificationState,
    helpText: t('signer_option_sms_notification_helptext'),
    disabled: !mobileIsValid || !SMSNotificationFeatureEnabled || order.uiFeatures.smsNotification.includes('disabled')
  })))), features.handwritten.available ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_combine_handwritten",
    label: t('signer_option_combine_handwritten_label'),
    onChange: handleHandwrittenToggle,
    checked: signerData.addHandwrittenSignature,
    helpText: "".concat(t('signer_option_combine_handwritten_helptext'), "\n                            ").concat(pkiIsAvailable ? " ".concat(t('signer_option_not_available_with_pki')) : '', "\n                          "),
    disabled: disableAddHandwrittenSignature
  }))) : null, features.authBeforeSign.available ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_require_authentication",
    label: t('signer_option_require_authentication_label'),
    onChange: handleAuthBeforeSignToggle,
    checked: signerData.authBeforeSign === 'sms',
    helpText: t('signer_option_require_authentication_helptext'),
    disabled: features.authBeforeSign.disabled || !mobileIsValid || order.uiFeatures.requireAuthentication.includes('disabled')
  }))) : null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_required_signer",
    label: t('signer_option_required_signer_label'),
    onChange: handleSignerToggle('required'),
    checked: signerData.required,
    helpText: requiredDisabled ? t('signer_option_required_signer_helptext_disabled') : t('signer_option_required_signer_helptext'),
    disabled: requiredDisabled
  }))), (order === null || order === void 0 ? void 0 : (_order$uiFeatures17 = order.uiFeatures) === null || _order$uiFeatures17 === void 0 ? void 0 : _order$uiFeatures17.showShare) === 'hidden' ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "signer_option_share_signed_documents",
    label: t('signer_option_share_signed_documents_label'),
    onChange: handleSignerShareChange,
    checked: Boolean((_signerData$addons6 = signerData.addons) === null || _signerData$addons6 === void 0 ? void 0 : _signerData$addons6.shareDocumentAfterSigned),
    disabled: (order === null || order === void 0 ? void 0 : (_order$uiFeatures18 = order.uiFeatures) === null || _order$uiFeatures18 === void 0 ? void 0 : (_order$uiFeatures18$s = _order$uiFeatures18.secureShare) === null || _order$uiFeatures18$s === void 0 ? void 0 : _order$uiFeatures18$s.includes('disabled')) || !allowShare || !mobileIsValid && ((order === null || order === void 0 ? void 0 : (_order$uiFeatures19 = order.uiFeatures) === null || _order$uiFeatures19 === void 0 ? void 0 : _order$uiFeatures19.showShare) == 'enabled_with_email_and_sms' || (order === null || order === void 0 ? void 0 : (_order$uiFeatures20 = order.uiFeatures) === null || _order$uiFeatures20 === void 0 ? void 0 : _order$uiFeatures20.showShare) == 'enabled_with_email' && signerData.signatureMethods.some(function (x) {
      return x.signMechanism === 'handwritten';
    })),
    helpText: "\n                          ".concat(t('signer_option_share_signed_documents_helptext'), "\n                          ").concat((order === null || order === void 0 ? void 0 : (_order$uiFeatures21 = order.uiFeatures) === null || _order$uiFeatures21 === void 0 ? void 0 : _order$uiFeatures21.showShare) == 'enabled_with_email_and_sms' || (order === null || order === void 0 ? void 0 : (_order$uiFeatures22 = order.uiFeatures) === null || _order$uiFeatures22 === void 0 ? void 0 : _order$uiFeatures22.showShare) == 'enabled_with_email' && signerData.signatureMethods.some(function (x) {
      return x.signMechanism === 'handwritten';
    }) ? t('requires_email_and_mobile') : t('requires_email'))
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    style: {
      borderLeft: media.matches.tablet.and('down') ? 'none' : '2px solid #EEEEEE'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Heading, {
    center: true,
    level: 4
  }, t('signorder_heading_documents')), signerData.signerRoles && order.documents.sort(function (a, b) {
    return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
  }).map(function (doc, i) {
    return signerData.signerRoles[doc.id] && signerRoleEl({
      id: doc.id,
      index: i,
      type: 'document',
      title: doc.title
    });
  }), signerData.signerRoles && order.attachments.sort(function (a, b) {
    return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
  }).map(function (attachment, i) {
    return signerData.signerRoles[attachment.id] && signerRoleEl({
      id: attachment.id,
      index: i,
      type: 'attachment',
      title: attachment.title
    });
  })))), /*#__PURE__*/React.createElement(Row, {
    vertical: "center",
    horizontal: "end"
  }, /*#__PURE__*/React.createElement(Column, {
    flex: "none",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "cancel",
    variant: "outlined",
    color: "anonymous",
    onClick: handleCancelClick,
    size: "sm",
    disabled: isSaving
  }, t('button_text_cancel')), /*#__PURE__*/React.createElement(Button, {
    icon: "check",
    primary: true,
    onClick: saveAndClose,
    size: "sm",
    disabled: isSaving
  }, t('button_text_done'))))))))));
};
export default SignerEdit;